import * as React from "react";
import type { SVGProps } from "react";
export const SvgYearInReviewSupport = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 30 30" {...props}>
    <path
      fill="currentColor"
      d="M19 26.785 15 30l-4-3.215 3.195-16.152.805 1.083.805-1.083L19 26.785ZM8.519 6.38 12 9.813 9.712 17.08l-5.272-2.12 3.283-4.34C7.686 10.621.568 11.052 0 6.38h8.519ZM30 6.38c-.568 4.673-7.686 4.242-7.723 4.24l3.283 4.34-5.272 2.121L18 9.813l3.481-3.433H30ZM20 2.222l-5 6.133-5-6.133L11.255 0h7.49L20 2.222Z"
    />
  </svg>
);
